import React from 'react';

export const ProfessionalDevelopment = ({ data }) => {
  const renderTraining = (courses) => {
    return courses.map((course, i) => {
      return (
        <div key={`${course.name}-${i}`} className="col-md-12">
          <h4 className='proDev'>{course.name}</h4>
          <p className='info'>{course.degree}</p>
          <p className="description">{course.description}</p>
        </div>
      );
    });
  };

  const renderLanguages = (languages) => {
    return languages.map((language, i) => {
      return (
        <div key={`${language.title}-${i}`} className="col-md-12">
          <h4 className='proDev'>{language.title}</h4>
          <p className="description">{language.description}</p>
        </div>
      );
    });
  };

  return (
    <div id="professionalDevelopment">
      <div className="container">
        <div className="section-title text-center">
          <h2>Professional Development</h2>
        </div>
        {data ? (
          <div>
            <div className="row section-info">
              <div className="col-md-3">
                <h3 className='header'>Training</h3>
              </div>

              <div className="col-md-9">
                <div className="row item">
                  <div className="col-md-12 proDev-items">
                    {renderTraining(data.trainings)}
                  </div>
                </div>
              </div>
            </div>

            <div className="row section-info">
              <div className="col-md-3">
                <h3 className='header'>Languages</h3>
              </div>

              <div className="col-md-9">
                <div className="row item">
                  <div className="col-md-12 proDev-items">
                    {renderLanguages(data.languages)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          'loading...'
        )}
      </div>
    </div>
  );
};
